import api from "./api";

export const searchService = {
    async global(q, limit = 5) {
        const { data } = await api.get("/search", { params: { q, limit } });
        return data;
    },
};
